import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from './components/UI'
import mixins from './mixins'
import './index.css'
const app = createApp(App)

components.forEach(component => {
    app.component(component.name, component)
})

mixins.forEach(mixin => {
    app.mixin(mixin)
})

app
    .use(store)
    .use(router)
    .mount('#app')